export default "/images/vendor/flag-icon-css/flags/1x1/gf.svg?3af44a6e434c403b3fdd9b165fab17a5";